export default "/images/vendor/flag-icons/flags/1x1/arab.svg?38625ae0698b498a48fd43432bb65c03";